<template>
  <div class="goods1">
    <div class="mb20">可以编辑背景图，标题和简介。背景图推荐1200*410像素</div>
    <el-form :model="currentInfo" label-width="80px">
      <el-form-item label="标题">
        <el-input placeholder="请输入标题" v-model="currentInfo.title" />
      </el-form-item>
      <el-form-item label="内容">
        <el-input
          type="textarea"
          placeholder="请填写内容"
          v-model="currentInfo.content"
          :autosize="{ minRows: 4, maxRows: 6 }"
        />
      </el-form-item>
      <el-form-item label="查看详情">
        <el-input placeholder="请输入链接地址" v-model="currentInfo.linkUrl" />
      </el-form-item>
      <el-form-item label="背景图片">
        <el-upload
          :action="fileObj.url"
          :before-upload="beforeUpload"
          :on-success="successUpdate"
          :headers="reqData"
          :show-file-list="false"
        >
          <img
            class="list-img"
            v-if="currentInfo.picture"
            :src="currentInfo.picture"
            @click="updateImg()"
          />
          <i class="el-icon-plus" v-else />
        </el-upload>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
export default {
  mixins: [codeMixin],
  methods: {},
};
</script>
<style lang="less" scoped>
.goods1 {
  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    border: 1px dashed rgb(196, 192, 192);
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    .el-icon-plus {
      font-size: 36px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
  .jc-sb {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 10px;
    background: #eee;
    border-radius: 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/propaganda/propaganda1/setting.vue